<template>
  <div class="filter-config-editor">
    <b-field
      class="input-field"
      label="Filter"
      :type="errors.length ? 'is-danger' : ''"
      :message="errorMessages">
      <FilterEditor v-model="inputs.filter" />
    </b-field>
    <b-field
      class="input-field mt-5"
      label="Filter time range (optional):">
      <TimeRangeEditor
        v-model="inputs.time_range"
        :default-option-label="defaultTimeRangeLabel"
        :default-time-range-name="defaultTimeRange?.name || ''"
        :default-time-range="defaultTimeRange"
        @example-date-change="timeRangeExampleDate = $event" />
    </b-field>
    <div class="mt-5">
      <TimeTransformEditor
        :offset-days="inputs.offset_days || 0"
        :repeat-config="inputs.repeat_config"
        :effective-time-range="inputs.time_range || defaultTimeRange"
        :example-report-date="timeRangeExampleDate"
        @update:offsetDays="$set(inputs, 'offset_days', $event)"
        @update:repeatConfig="$set(inputs, 'repeat_config', $event)" />
    </div>
  </div>
</template>

<script>
  import FilterEditor from '@/components/reports/config/filters/FilterEditor'
  import ModuleConfigMixin from '@/components/reports/config/modules/common/ModuleConfigMixin'
  import TimeRangeEditor from '@/components/reports/config/modules/common/TimeRangeEditor'
  import TimeTransformEditor from '@/components/reports/config/modules/common/TimeTransformEditor'

  export default {
    name: 'FilterConfigEditor',
    components: {
      FilterEditor,
      TimeRangeEditor,
      TimeTransformEditor,
    },
    mixins: [ModuleConfigMixin,],
    props: {
      errors: {
        type: Array,
        default: () => [],
      },
      defaultTimeRange: {
        type: Object,
        default: null,
      },
      defaultTimeRangeLabel: {
        type: String,
        default: 'Use measure default',
      },
    },
    data () {
      return {
        timeRangeExampleDate: null,
      }
    },
    computed: {
      errorMessages () {
        if (!this.errors.length) return ''
        return this.errors.map(e => e.msg).join(', ')
      },
    },
  }
</script>

<style lang="scss" scoped>
.filter-config-editor {
  padding: 8px;
}
.benchmark-inputs {
  margin-top: 30px;
}
</style>
